import React from "react";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import { connect, useSelector } from "react-redux";
import * as advertRedux from "modules/Advert/_redux/advertRedux";

// Buyer (Aranan) ilan: kabul edilen metrekare aralığı (m2Min - m2Max).
// Redux: newAdvert.filters.m2Min, newAdvert.filters.m2Max.
function FLBuyerM2Range(props) {
  const { filters } = useSelector((state) => ({
    filters: state.advert.newAdvert.filters,
  }));

  const m2Min = filters?.m2Min ?? "";
  const m2Max = filters?.m2Max ?? "";

  return (
    <div style={{ display: "flex", gap: 8, width: "100%" }}>
      <TextField
        type="number"
        label="En Az m²"
        variant="outlined"
        margin="dense"
        fullWidth
        value={m2Min}
        onChange={(e) =>
          props.editNewAdvertFilters(
            "m2Min",
            e.target.value === "" ? "" : Number(e.target.value)
          )
        }
        inputProps={{ min: 0 }}
        InputProps={{ endAdornment: <InputAdornment position="end">m²</InputAdornment> }}
      />
      <TextField
        type="number"
        label="En Çok m²"
        variant="outlined"
        margin="dense"
        fullWidth
        value={m2Max}
        onChange={(e) =>
          props.editNewAdvertFilters(
            "m2Max",
            e.target.value === "" ? "" : Number(e.target.value)
          )
        }
        inputProps={{ min: 0 }}
        InputProps={{ endAdornment: <InputAdornment position="end">m²</InputAdornment> }}
      />
    </div>
  );
}

export default connect(null, { ...advertRedux.actions })(FLBuyerM2Range);
